import { useState } from "react";
import { RefreshCw, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/auth/AuthContext";
import { magicRenew } from "@/lib/api";

// "Your login will expire in X days — tap to renew" for field (magic-link)
// sessions with < 5 days left, online only.
export default function FieldSessionBanner() {
  const { user, refresh } = useAuth();
  const [busy, setBusy] = useState(false);
  const fs = user?.field_session;
  if (!fs || !fs.renew_prompt || (typeof navigator !== "undefined" && navigator.onLine === false)) return null;
  const renew = async () => {
    setBusy(true);
    try {
      const { data } = await magicRenew();
      await refresh();
      toast.success(data.hard_max_reached
        ? "Renewed to the maximum — you will need a new email link after it ends."
        : `Renewed — signed in for ${data.field_session.days_left} more days.`);
    } catch { toast.error("Could not renew — request a new sign-in link."); }
    finally { setBusy(false); }
  };
  return (
    <button type="button" onClick={renew} disabled={busy}
            className="w-full bg-amber-500 text-slate-900 text-xs font-semibold px-3 py-2 flex items-center justify-center gap-2"
            data-testid="field-session-banner">
      {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <RefreshCw className="w-3.5 h-3.5" />}
      Your login will expire in {fs.days_left} day{fs.days_left === 1 ? "" : "s"} — tap to renew
    </button>
  );
}
